import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2270,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 92,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/panacnnc_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1wwpiqjc_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jl9j7lqf_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tn42e7i0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p63aucsa_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 90,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fssd848h_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Chats"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 42,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/levey8f3_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/msua0qg5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h5si6eef_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 32,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tscz1nwz_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/yof8dt2e_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rem5qnu8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/15bmeo28_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7ip5gcot_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wmqdfu7u_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/p2xv5f6j_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 2,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/08g62oc1_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lfoaf0eu_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zotkjqnd_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/turcqeyu_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 31,
							marginLeft: 267,
						}} >
						{"Giia AI Agent"}
					</span>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingLeft: 20,
							paddingRight: 20,
							marginLeft: 267,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginRight: 23,
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 20,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/uyakwiz8_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 20,
										fontWeight: "bold",
									}} >
									{"Giia"}
								</span>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 225,
									marginBottom: 21,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g2b3mzj7_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search chat..."}
									value={input3}
									onChange={(event)=>onChangeInput3(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 88,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f4ndtc71_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 211,
									}} >
									{"Curriculum"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/65tgjb2q_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8p6mvnzc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 231,
									}} >
									{"Lessons"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/b99npt60_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/urq1m8vm_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 227,
									}} >
									{"Progress"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bl3a5wqz_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1v3zgrvc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 214,
									}} >
									{"Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/54mtga5q_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mqvyay9p_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 206,
									}} >
									{"Community"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2810wclh_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/227erdx0_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 189,
									}} >
									{"Chats History"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/h9o8pqe0_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ecu823nx_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 125,
									}} >
									{"Bookmarks Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s4zw3ets_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 19,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0kuuqjtv_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										marginRight: 18,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 125,
									}} >
									{"Downloads Resources"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cqt4pxz5_expires_30_days.png"} 
									style={{
										width: 27,
										height: 23,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									width: 362,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 82,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
									borderRadius: 12,
									paddingTop: 22,
									paddingBottom: 22,
									paddingLeft: 23,
									paddingRight: 115,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mv8ef2lf_expires_30_days.png"} 
									style={{
										width: 48,
										height: 48,
										objectFit: "fill",
									}}
								/>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										gap: 8,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											gap: 11,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 16,
												fontWeight: "bold",
											}} >
											{"Guy Hawkins"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 3,
												paddingLeft: 6,
												paddingRight: 6,
											}}>
											<span 
												style={{
													color: "#FFFFFF",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"mentor"}
											</span>
										</div>
									</div>
									<div 
										style={{
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 6,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mpq06qa2_expires_30_days.png"} 
											style={{
												width: 15,
												height: 15,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"yourguy123@email.com"}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 834,
								background: "#E6E6E6",
								marginRight: 18,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
							}}>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									paddingBottom: 1,
									marginBottom: 28,
									marginLeft: 294,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Chats History"}
								</span>
							</div>
							<div 
								style={{
									width: 691,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 27,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 20,
									paddingRight: 185,
									marginBottom: 24,
									marginLeft: 14,
									marginRight: 14,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/9o5tsvxy_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search conversations with Giia..."}
									value={input4}
									onChange={(event)=>onChangeInput4(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 213,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 16,
									marginLeft: 22,
								}} >
								{"Today"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FEF0E9",
									borderRadius: 8,
									border: "none",
									paddingTop: 12,
									paddingBottom: 12,
									paddingLeft: 16,
									paddingRight: 16,
									marginBottom: 28,
									marginLeft: 14,
									marginRight: 14,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#010101",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 359,
									}} >
									{"How do I create a marketing strategy?"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/znmxsxiy_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</button>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 28,
									marginLeft: 22,
								}} >
								{"Last 7 Days"}
							</span>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 28,
									marginLeft: 22,
								}} >
								{"Giia, generate a financial plan for my startup."}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 461,
									}} >
									{"Mentorship Discussions"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bv8hw08j_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 461,
									}} >
									{"Mentorship Discussions"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/t9frtszy_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 457,
									}} >
									{"Business Strategy Chats"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ou3h3pzo_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 28,
									marginLeft: 22,
								}} >
								{"Last 30 Days"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 460,
									}} >
									{"Building a Business Plan"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/d96oe8dl_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 436,
									}} >
									{"Market Research Strategies"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/x0akoyt5_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 28,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 395,
									}} >
									{"Financial Forecasting & Budgeting"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jekc5byx_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 438,
									}} >
									{"Social Media Growth Hacks"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4cinz330_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									fontWeight: "bold",
									marginBottom: 28,
									marginLeft: 22,
								}} >
								{"Last month"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 22,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginRight: 463,
									}} >
									{"Technology & AI Trends"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0z0rpscu_expires_30_days.png"} 
									style={{
										width: 7,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}